import styles from './Control.module.scss';

export const Control = ({text}) => {

    return (
        <div className={styles.control}>{text}</div>
    )
}